import config from "../config";

export async function signOut({ token }) {
  await fetch(`${config.api}/get/logout`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
